<template>
  <div class="space-y-4">
    <div
      class="flex justify-between items-center cursor-pointer hover:opacity-50"
      @click="collapsed = !collapsed"
    >
      <h3 class="font-bold flex justify-between items-center cursor-pointer">
        {{ props.title }}
      </h3>
      <div>
        <Icon v-if="collapsed" name="plus" /> <Icon v-else name="minus" />
      </div>
    </div>
    <Transition appear>
      <slot v-if="!collapsed" />
    </Transition>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
}>()

const collapsed = ref(false)
</script>
